import React, { createContext, useContext } from 'react';

const TableCellContext = createContext<any>(null);
import { ActionName } from '../fragments/types';

export type AcknowledgedValues = Record<ActionName, string[]>;

export interface AcknowledgedValuesProviderProps {
  valuesFromConfig?: AcknowledgedValues;
  children: React.ReactNode;
}

export const AcknowledgedValuesProvider = React.memo(
  ({ children, valuesFromConfig }: AcknowledgedValuesProviderProps): JSX.Element => {
    const [acknowledgedValues, setAcknowledgedValues] = React.useState<AcknowledgedValues | undefined>(
      valuesFromConfig,
    );
    return (
      <TableCellContext.Provider value={{ acknowledgedValues, setAcknowledgedValues }}>
        {children}
      </TableCellContext.Provider>
    );
  },
);
AcknowledgedValuesProvider.displayName = 'AcknowledgedValuesProvider';

export const useTableCellAction = (): any => useContext(TableCellContext);
